import axios from "axios";
import { takeLatest, call, put } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";
import { paramsToString } from "../../../../utils/parseToString.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_HEATMAP_DATA = "saga/FETCH_HEATMAP_DATA";
export const FETCH_HEATMAP_DATA_SUCCESS = "saga/FETCH_HEATMAP_DATA_SUCCESS";
export const FETCH_HEATMAP_DATA_FAILURE = "saga/FETCH_HEATMAP_DATA_FAILURE";

export const actionCreators = {
  fetchHeatmapData: createAction(FETCH_HEATMAP_DATA)
};

export default function* watchStars() {
  yield takeLatest(FETCH_HEATMAP_DATA, getHeatmapData);
}

export function* getHeatmapData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/retention/customer_retention_heatmap" +
        "?organization_id=" +
        payload.organizationId +
        "&short_url=" +
        payload.short_url +
        (payload.categories ? "&categories=" + paramsToString(payload.categories) : "") +
        (payload.classPass ? "&class_pass=" + payload.classPass : "") +
        (payload.numbersOrPercentages
          ? "&numbers_or_percentages=" + payload.numbersOrPercentages
          : "") +
        (payload.includeCrossRegionalVisits
          ? "&include_cross_regional_visits=" + payload.includeCrossRegionalVisits.value
          : "")
    );

    // TODO: this is correction from snake case to camel case, remove on backend fix
    const filters = res.data.filters;
    if (filters && filters.class_pass) {
      res.data.filters = {
        tooltip: filters.tooltip,
        classPass: filters.class_pass,
        numbersOrPercentages: filters.numbers_or_percentages,
        classPasses: filters.class_passess
      };
    }

    yield put({ type: FETCH_HEATMAP_DATA_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_HEATMAP_DATA_FAILURE, error });
  }
}
